import React from "react";
import preview from "../../../../assets/portfolio/netflix/preview.png";

export default function Netflix() {
	return (
		<div
			style={{
				margin: "0",
				marginTop: "4rem",
				width: "calc(100% - 2rem)",
			}}
			data-aos="fade-up">
			<h2
				style={{
					fontWeight: 400,
					fontSize: "16px",
					lineHeight: "16px",
					margin: "1rem 0",
				}}>
				Netflix, BBC, Hyundai, Incento{" "}
			</h2>
			<h3>Employee Incentivization Platform</h3>
			<p>App and desktop based incentive program for employees and students.</p>
			<div
				style={{
					width: "100%",
					height: "600px",
					overflow: "hidden",
					borderRadius: "10px",
					paddingLeft: "2rem",
					paddingTop: "2rem",
					backgroundColor: "#ffb11f",
				}}>
				<img
					src={preview}
					alt="Employee incentive tracking app"
					style={{ height: "100%" }}
				/>
			</div>
		</div>
	);
}
